module.exports = __webpack_public_path__ + "static/rococco-shoes_2008-56c95db11975c5dd272bdd31cfd9eabe.jpg";